import script from "./PriceCalculation.vue?vue&type=script&lang=ts&setup=true"
export * from "./PriceCalculation.vue?vue&type=script&lang=ts&setup=true"

import "./PriceCalculation.vue?vue&type=style&index=0&id=40ceca00&lang=scss"

const __exports__ = script;

export default __exports__